
// oss-音视频管理 接口
import request from '@/utils/request.js'

/**
* 添加文件
* @param params
* @returns {AxiosPromise}
*/
export function addFile(params) {
	console.log(params,'addfile传的参数');
	return request({
		url: '/studyService/api/ossMedia/addFile',
		method: 'post',
		data: params,
		closeLoading: true
	})
}

/**
* 校验名称是否存在
* @param params
* @returns {AxiosPromise}
*/
export function checkNameExist(params) {
	return request({
		url: '/studyService/api/ossMedia/checkNameExist',
		method: 'post',
		data: params
	})
}

/**
* 获取
* @param params
* @returns {AxiosPromise}
*/
export function get(params) {
	return request({
		url: '/studyService/api/ossMedia/get',
		method: 'post',
		data: params
	})
}

/**
* 列表
* @param params
* @returns {AxiosPromise}
*/
export function list(params) {
	return request({
		url: '/studyService/api/ossMedia/list',
		method: 'post',
		data: params
	})
}

/**
* 移动
* @param params
* @returns {AxiosPromise}
*/
export function move(params) {
	return request({
		url: '/studyService/api/ossMedia/move',
		method: 'post',
		data: params
	})
}

/**
* 删除
* @param params
* @returns {AxiosPromise}
*/
export function remove(params) {
	return request({
		url: '/studyService/api/ossMedia/remove',
		method: 'post',
		data: params
	})
}

/**
* 重命名
* @param params
* @returns {AxiosPromise}
*/
export function rename(params) {
	return request({
		url: '/studyService/api/ossMedia/rename',
		method: 'post',
		data: params
	})
}

/**
* 禁用/启用音视频
* @param params
* @returns {AxiosPromise}
*/
export function updateUseFlag(params) {
	return request({
		url: '/studyService/api/ossMedia/updateUseFlagBatch',
		method: 'post',
		data: params
	})
}
/**
* 导入试题
* @param params
* @returns {AxiosPromise}
*/
export function importQuestion(params) {
	return request({
		url: '/studyService/api/importQuestion/importQuestion',
		method: 'post',
		data: params
	})
}

// 方法列表
// addFile，checkNameExist，get，list，move，remove，rename，updateUseFlag